export default __webpack_public_path__ + "static/media/deadmanshandnormal.f5f30ebb.jpg";